import Rest from 'services/data/rest';

export default class WorkOrder extends Rest {
  static path = 'workOrder';
  static defaultQuery = {
    sort: ['status', 'number'],
    load: []
  };
}
